import React from "react";
import { FacebookShareButton, TwitterShareButton } from "react-share";

function ShareBox(info) {
    //id={id} link={params.block.link} mode="details/page" type="slide/stable"
    let id = info.id;

    const idCopy = id + '-copy';
    const idPaste = id + '-paste';
    const idClick = id + '-click';

    const copySVG = `
        <svg enable-background="new 0 0 512 512" fill="#fff" version="1.1" viewBox="0 0 512 512" xml:space="preserve" xmlns="http://www.w3.org/2000/svg">
            <g xmlns="http://www.w3.org/2000/svg" transform="matrix(0.49,0,0,0.49,130.5600583648681,130.5600992202758)"><g xmlns="http://www.w3.org/2000/svg"><path d="m307.148 35.148-104.067 104.066c-.201.2-.326.443-.526.645 25.637-3.734 51.974-1.174 76.388 8.346l70.63-70.63c23.399-23.399 61.454-23.399 84.853 0 23.399 23.397 23.399 61.454 0 84.851-3.99 3.992-110.083 110.085-104.066 104.066-23.584 23.586-62.276 22.577-84.853 0-11.693-11.693-30.731-11.693-42.426 0l-18.214 18.214c5.052 8.584 10.844 16.844 18.214 24.214 44.44 44.44 120.934 47.99 169.061.526.201-.2.443-.326.645-.526l104.066-104.066c46.862-46.864 46.862-122.842 0-169.706-46.864-46.864-122.841-46.864-169.705 0z"></path><path d="m233.285 363.568-70.858 70.858c-23.397 23.399-61.454 23.399-84.851 0-23.399-23.399-23.399-61.454 0-84.853 3.99-3.99 110.31-110.31 104.293-104.293 23.584-23.584 62.276-22.577 84.853 0 11.693 11.695 30.732 11.695 42.426 0l18.214-18.214c-5.052-8.584-10.844-16.844-18.214-24.212-44.355-44.357-120.793-48.131-169.061-.527-.201.2-.443.326-.645.527l-104.294 104.294c-46.862 46.862-46.864 122.842 0 169.706 46.864 46.862 122.844 46.862 169.706 0l104.293-104.295c.201-.2.326-.441.526-.645-25.637 3.734-51.973 1.174-76.388-8.346z"></path></g></g>
            <path d="m256 0c-141.38 0-256 114.62-256 256s114.62 256 256 256 256-114.62 256-256-114.62-256-256-256zm0 488.73c-128.53 0-232.73-104.2-232.73-232.73s104.2-232.73 232.73-232.73 232.73 104.2 232.73 232.73-104.2 232.73-232.73 232.73z"></path>
        </svg>
    `;
    const fbSVG = `
        <svg enable-background="new 0 0 512 512" fill="#fff" version="1.1" viewBox="0 0 512 512" xml:space="preserve" xmlns="http://www.w3.org/2000/svg">
            <path d="m232.73 197.82v23.273h-23.273v34.909h23.273v104.73h46.545v-104.73h30.953l3.956-34.909h-34.909v-20.364c0-9.425 0.931-14.429 15.476-14.429h19.433v-35.026h-31.185c-37.236 1e-3 -50.269 17.455-50.269 46.546z"></path>
            <path d="m256 0c-141.38 0-256 114.62-256 256s114.62 256 256 256 256-114.62 256-256-114.62-256-256-256zm0 488.73c-128.53 0-232.73-104.2-232.73-232.73s104.2-232.73 232.73-232.73 232.73 104.2 232.73 232.73-104.2 232.73-232.73 232.73z"></path>
        </svg>
    `;
    const twSVG = `
        <svg enable-background="new 0 0 512 512" fill="#fff" version="1.1" viewBox="0 0 512 512" xml:space="preserve" xmlns="http://www.w3.org/2000/svg">
            <path d="m377.6 166.4c-9.394 5.566-19.663 9.5-30.371 11.636-9.1-9.544-21.722-14.93-34.909-14.895-25.977-0.195-47.263 20.571-47.709 46.545 0.011 3.606 0.44 7.199 1.28 10.706-38.258-1.806-73.989-19.629-98.444-49.105-4.183 7.049-6.431 15.077-6.516 23.273 1e-3 15.803 8.02 30.525 21.295 39.098-7.581-0.247-14.997-2.28-21.644-5.935v0.582c-0.076 22.697 15.998 42.241 38.284 46.545-7.025 1.873-14.381 2.151-21.527 0.815 6.425 19.226 24.298 32.292 44.567 32.582-16.874 13.122-37.621 20.283-58.996 20.364-3.889-4e-3 -7.775-0.237-11.636-0.698 21.898 13.852 47.281 21.197 73.193 21.178 73.893 1.35 134.89-57.459 136.24-131.35 0.014-0.783 0.022-1.566 0.022-2.35v-6.051c9.12-6.684 16.997-14.915 23.273-24.32-8.736 3.825-17.99 6.334-27.462 7.447 9.961-5.831 17.451-15.1 21.06-26.065z"></path>
            <path d="m256 0c-141.38 0-256 114.62-256 256s114.62 256 256 256 256-114.62 256-256-114.62-256-256-256zm0 488.73c-128.53 0-232.73-104.2-232.73-232.73s104.2-232.73 232.73-232.73 232.73 104.2 232.73 232.73-104.2 232.73-232.73 232.73z"></path>
        </svg>
    `;
    const shareIcon = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.com/svgjs" version="1.1" width="512" height="512" x="0" y="0" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512" xml:space="preserve" className=""><g><path xmlns="http://www.w3.org/2000/svg" d="m389.332031 160c-44.09375 0-80-35.882812-80-80s35.90625-80 80-80c44.097657 0 80 35.882812 80 80s-35.902343 80-80 80zm0-128c-26.453125 0-48 21.523438-48 48s21.546875 48 48 48 48-21.523438 48-48-21.546875-48-48-48zm0 0" fill="#ffffff" data-original="#ffffff" className=""/><path xmlns="http://www.w3.org/2000/svg" d="m389.332031 512c-44.09375 0-80-35.882812-80-80s35.90625-80 80-80c44.097657 0 80 35.882812 80 80s-35.902343 80-80 80zm0-128c-26.453125 0-48 21.523438-48 48s21.546875 48 48 48 48-21.523438 48-48-21.546875-48-48-48zm0 0" fill="#ffffff" data-original="#ffffff" className=""/><path xmlns="http://www.w3.org/2000/svg" d="m80 336c-44.097656 0-80-35.882812-80-80s35.902344-80 80-80 80 35.882812 80 80-35.902344 80-80 80zm0-128c-26.453125 0-48 21.523438-48 48s21.546875 48 48 48 48-21.523438 48-48-21.546875-48-48-48zm0 0" fill="#ffffff" data-original="#ffffff" className=""/><path xmlns="http://www.w3.org/2000/svg" d="m135.703125 240.425781c-5.570313 0-10.988281-2.902343-13.910156-8.0625-4.375-7.679687-1.707031-17.453125 5.972656-21.824219l197.953125-112.855468c7.65625-4.414063 17.449219-1.726563 21.800781 5.976562 4.375 7.679688 1.707031 17.449219-5.972656 21.824219l-197.953125 112.851563c-2.496094 1.40625-5.203125 2.089843-7.890625 2.089843zm0 0" fill="#ffffff" data-original="#ffffff" className=""/><path xmlns="http://www.w3.org/2000/svg" d="m333.632812 416.425781c-2.6875 0-5.398437-.683593-7.894531-2.109375l-197.953125-112.855468c-7.679687-4.371094-10.34375-14.144532-5.972656-21.824219 4.351562-7.699219 14.125-10.367188 21.804688-5.972657l197.949218 112.851563c7.679688 4.375 10.347656 14.144531 5.976563 21.824219-2.945313 5.183594-8.363281 8.085937-13.910157 8.085937zm0 0" fill="#ffffff" data-original="#ffffff" className=""/></g></svg>`;

    function copyLink(params) {
        //const paste = document.getElementById(params.id+'-paste');
        const copy = document.getElementById(params.id+'-copy');
        if (copy) {
            /*paste.innerHTML = copy.innerHTML;
            paste.select();
            document.execCommand("copy");*/
            navigator.clipboard.writeText(copy.innerHTML)

            const elem = document.createElement('div');
            const info = document.createTextNode('SKOPIOWANO LINK');
            elem.appendChild(info);
            elem.classList.add('link-copied');
            document.querySelector('body').appendChild(elem);
            setTimeout(function(){
                elem.remove();
            }, 3000);
        }
    }
    
    function detailsLink(link) {
        let url = ''
        if (link.includes('http')) {
            if (link.includes("/sites/widzew")) {
                url = link.split('/sites/widzew');
                url = url[1];
            }
            else {
                let uri = new URL(link)
                    url = uri.pathname;
            }
            return (window.location.origin + url)   
        }
        else {
            url = link;
            return (window.location.origin + url)
        }
    }
    
    return (
        <div className={`share-box type-`+info.type} title="Udostępnij">
            <div className="share-slide d-flex ai-center">
                {info.mode == 'page' && <p>UDOSTĘPNIJ</p>}
                <FacebookShareButton
                    url={detailsLink(info.link)}
                    quote={info.title}
                    className=""
                >
                    <span className="share-b" title="Udostępnij na Facebook">
                        <span className="share-fb"
                            dangerouslySetInnerHTML= {
                                { __html: fbSVG }
                            }
                        ></span>
                    </span>
                </FacebookShareButton>
                <TwitterShareButton
                    url={detailsLink(info.link)}
                    quote={info.title}
                    className=""
                >
                    <span className="share-b" title="Udostępnij na Twitter">
                        <span className="share-tw"
                            dangerouslySetInnerHTML= {
                                { __html: twSVG }
                            }
                        ></span>
                    </span>
                </TwitterShareButton>
                <span className="share-b" id={idClick} onClick={() => {copyLink({id})}} title="Skopiuj link">
                    <span className="copy-icon"
                        dangerouslySetInnerHTML= {
                            { __html: copySVG }
                        }
                    ></span>
                </span>
            </div>
            <span className="share-link" id={idCopy}>
                {detailsLink(info.link)}
            </span>
            {/*<textarea className="copy-area" id={idPaste} rows="1" cols="30"></textarea>*/}
            {info.mode == 'details' && 
                <span className="share-icon"
                    dangerouslySetInnerHTML= {
                        { __html: shareIcon }
                    }
                ></span>
            }
        </div>
    )
}

export default ShareBox;